<mat-accordion #accordion="matAccordion" [multi]="true">
  <!-- Luồng trình tự các bên Chủ thể -->
  <mat-expansion-panel *ngIf="check == 1" expanded="true" class="mat-elevation-z0">
    <mat-expansion-panel-header>
      <!--      <mat-panel-title class="mat-panel-title">-->
      <!--      </mat-panel-title>-->
      <mat-panel-description class="mat-panel-title">
         <div class="title-contract-party">
          <div class="title" *ngIf="!isPlContract">
            {{ "form.contracting_parties" | translate }}
            <mat-icon class="mr-0 text-primary" style="font-size: x-large; cursor: pointer; margin-left: 8px;"
                      matTooltip="{{ 'procedure.choose_procedure_full' | translate }}" (click)="openDialogProcedure(1, $event)">
              add_circle_outline
            </mat-icon>
          </div>
          <div class="note" *ngIf="selectedServiceType?.internalFlowNotEdit">{{ "form.note_contracting_parties" | translate }}</div>
        </div>
      </mat-panel-description>
      
    </mat-expansion-panel-header>
    <!-- Nz-table set luồng chủ thể -->
    <form nz-form>
      <div class="note2">
        <div class="note-title">
            {{ "form.note_sign" | translate }}
        </div>
    
        <div class="note-item">
            {{ "form.note_sign_2" | translate }}
        </div>
    
        <div class="note-item">
            {{ "form.note_sign_3" | translate }}
        </div>
    </div>
      <!-- <span class="float-right" *ngIf="this.valueSelect == '0' ">
  {{'enterprise_contract.panel_document.table_parties.guide_checkbox' | translate}}</span> -->
      <nz-table #partyRowTable nzBordered [nzData]="RECORD_PARTY_SIGN" [nzShowPagination]="false"
                [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom no-ant-table-placeholder">
        <thead>
        <tr>
          <th class="text-center border-color-table" nzWidth="55px">
            {{
              "enterprise_contract.panel_document.table_parties.header.order"
                | translate
            }}
          </th>
          <th class="text-center border-color-table">
            {{
              "enterprise_contract.panel_document.table_parties.header.party_name"
                | translate
            }}
          </th>
          <th class="text-center border-color-table" nzWidth="30%">
            {{
              "enterprise_contract.panel_document.table_parties.header.email"
                | translate
            }}
          </th>
          <th class="text-center border-color-table" nzWidth="18%" colspan="2" *ngIf="!isNotAttestedUser" >
            {{
              "enterprise_contract.panel_document.table_parties.header.phone"
                | translate
            }}
          </th>
          <th class="text-center border-color-table" nzWidth="18%" *ngIf="isNotAttestedUser" >
            {{
              "enterprise_contract.panel_document.table_parties.header.phone"
                | translate
            }}
          </th>
          <!--            <th nzWidth="25px" *ngIf="!isNotAttestedUser">-->
          <!--              {{-->
          <!--              "enterprise_contract.panel_document.table_parties.header.sign_no_login"-->
          <!--              | translate-->
          <!--              }}-->
          <!--            </th>-->
          <th class="border-color-table" nzWidth="25px" *ngIf="valueSelect === '0'">
            {{
              "enterprise_contract.panel_document.table_parties.header.insert_infor"
                | translate
            }}
          </th>
          <!-- Nếu chọn lập từ mẫu thì hiển thị cột chọn khách hàng để fill thông tin vào template-->
          <th class="border-color-table" nzWidth="34px">
            <div style="min-width: 34px;"></div>
          </th>
        </tr>
        </thead>
        <tbody *ngFor="let data of partyRowTable.data; let i = index">
        <tr class="editable-row">
          <!-- TT -->
          <td class="text-center" rowspan="2"*ngIf="!data.isCreatedSide" [ngClass]="{'border-color-table':(data.customerType && !data.isSetupSignFlow)}">
            <nz-input-number class="td-nz-input" [(ngModel)]="data.order" [nzMin]="1"
                             (ngModelChange)="onChangeOrderOfPartySign()" [ngModelOptions]="{ standalone: true }">
            </nz-input-number>
          </td>
          <td class="text-center" *ngIf="data.isCreatedSide"  >
            <nz-input-number class="td-nz-input" [(ngModel)]="data.order" [nzMin]="1"
                             (ngModelChange)="onChangeOrderOfPartySign()" [ngModelOptions]="{ standalone: true }">
            </nz-input-number>
          </td>
          <!-- Tên -->
          <td class="word-break-line" [ngClass]="{'border-color-table':data.customerType == 10000}">
            {{ data.name }}
          </td>
          <!-- Email -->
          <td class="word-break-line" [ngClass]="{'border-color-table':data.customerType == 10000}">
            <div *ngIf="data.isCreatedSide">{{ data.email }}</div>
            <div *ngIf="!data.isCreatedSide">
              <nz-form-item class="nz-form-item-customize">
                <nz-form-control nzHasFeedback [nzValidateStatus]="matchesRegex('email', data.email) ? 'error' : ''">
                  <input nz-input [(ngModel)]="data.email" (keydown)="setFormChanging(true)"
                         (ngModelChange)="onChangeEnterpriseValue('email', data)" [ngModelOptions]="{ standalone: true }"
                         placeholder="{{ 'placeholder.email' | translate }}" [required]="scopeType == 1" [pattern]="emailPattern" [disabled]="data.customerId === customerMohaId && isPlContract"
                         />
                </nz-form-control>
              </nz-form-item>
            </div>
          </td>

          <!-- Phone -->
          <td class="word-break-line"  *ngIf="isNotAttestedUser" [ngClass]="{'border-color-table':data.customerType == 10000}">
            <div *ngIf="data.isCreatedSide">{{ data.phone }}</div>
            <div *ngIf="!data.isCreatedSide">
              <nz-form-item class="nz-form-item-customize">
                <nz-form-control nzHasFeedback [nzValidateStatus]="matchesRegex('phone', data.phone) ? 'error' : ''">
                  <input nz-input [(ngModel)]="data.phone" (keydown)="setFormChanging(true)"
                         (ngModelChange)="onChangeEnterpriseValue('phone', data)" [ngModelOptions]="{ standalone: true }"
                         maxlength="15" [pattern]="phonePattern2" required  [disabled]="data.customerId === customerMohaId && isPlContract"
                         />
                </nz-form-control>
              </nz-form-item>
            </div>
          </td>
          <td class="word-break-line" colspan="2" *ngIf="!isNotAttestedUser" [ngClass]="{'border-color-table':data.customerType == 10000}">
            <div *ngIf="data.isCreatedSide">{{ data.phone }}</div>
            <div *ngIf="!data.isCreatedSide">
              <nz-form-item class="nz-form-item-customize">
                <nz-form-control nzHasFeedback [nzValidateStatus]="matchesRegex('phone', data.phone) ? 'error' : ''">
                  <input nz-input [(ngModel)]="data.phone" (keydown)="setFormChanging(true)"
                         (ngModelChange)="onChangeEnterpriseValue('phone', data)" [ngModelOptions]="{ standalone: true }"
                         maxlength="15" [pattern]="phonePattern2" required  [disabled]="data.customerId === customerMohaId && isPlContract"/>
                </nz-form-control>
              </nz-form-item>
            </div>
          </td>
          <td *ngIf="this.valueSelect == '0'" class="text-center" [ngClass]="{'border-color-table':data.customerType == 10000}">
            <label nz-checkbox [(ngModel)]="data.useDataForTemplate" [ngModelOptions]="{ standalone: true }"
                   *ngIf="!data.isCreatedSide" (ngModelChange)="
                  onSelectCustomerForTemplate(
                    data.customerId,
                    data.useDataForTemplate
                  )
                "></label>
          </td>
          <td class="text-center" *ngIf="data.isCreatedSide">
            <div class="d-flex justify-content-center">
              <!-- <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{
                  'popup.confirm_delete_party' | translate
                }}" (nzOnConfirm)="
                  onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)
                " [nzIcon]="iconDel" nzCancelText="{{ 'button.cancel' | translate }}"
                 nzOkText="{{ 'button.ok' | translate }}">
                <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
              </a>
              <ng-template #iconDel>
                <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
              </ng-template> -->

              <a (click)="isShowUserSignTable = !isShowUserSignTable" *ngIf="data.isCreatedSide"
                 style="transition: 0.3s; display: flex; align-items: center;"
                 [ngStyle]="{'transform': !isShowUserSignTable ? 'rotate(0deg)' : 'rotate(180deg)'}">
                <i class="fa fa-angle-down" aria-hidden="true" nzIcon style="font-size: 17px;"
                   matTooltip="{{ (isShowUserSignTable ? 'tooltips.hidden' : 'tooltips.show') | translate }}"></i>
              </a>
            </div>
          </td>
          <td class="text-center" rowspan="2"*ngIf="!data.isCreatedSide" [ngClass]="{'border-color-table':(data.customerType && !data.isSetupSignFlow)}">
            <div class="d-flex justify-content-center">
              <ng-container *ngIf="!isPlContract">
                <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{
                    'popup.confirm_delete_party' | translate
                  }}" (nzOnConfirm)="
                    onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)
                  " [nzIcon]="iconDel" nzCancelText="{{ 'button.cancel' | translate }}"
                  nzOkText="{{ 'button.ok' | translate }}">
                  <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                </a>
                <ng-template #iconDel>
                  <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                </ng-template>
              </ng-container>

              <ng-container *ngIf="isPlContract">
                <a *ngIf="data.customerId !== customerMohaId" class="text-center" nz-popconfirm nzPopconfirmTitle="{{
                    'popup.confirm_delete_party' | translate
                  }}" (nzOnConfirm)="
                    onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)
                  " [nzIcon]="iconDel" nzCancelText="{{ 'button.cancel' | translate }}"
                  nzOkText="{{ 'button.ok' | translate }}">
                  <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                </a>
                <ng-template #iconDel>
                  <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                </ng-template>

                <a *ngIf="data.customerId === customerMohaId && isPlContract"
                >
                  <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
                </a>
              </ng-container>
             
              <!-- <a (click)="isShowUserSignTable = !isShowUserSignTable" *ngIf="data.isCreatedSide"
                 style="transition: 0.3s; margin-left: 7px; display: flex; align-items: center;"
                 [ngStyle]="{'transform': !isShowUserSignTable ? 'rotate(0deg)' : 'rotate(180deg)'}">
                <i class="fa fa-angle-down" aria-hidden="true" nzIcon style="font-size: 17px;"
                   matTooltip="{{ (isShowUserSignTable ? 'tooltips.hidden' : 'tooltips.show') | translate }}"></i>
              </a> -->
            </div>
          </td>
        </tr>
        <!-- <tr *ngIf="!data.isCreatedSide && !isNotAttestedUser">
          <td colspan="4" *ngIf="!isNotAttestedUser" [ngClass]="{'border-color-table':!data.isSetupSignFlow,'border-color-table-none':data.isSetupSignFlow}" >
            <div class="row">
              <div class="col-auto  pr-0">
                <label nz-checkbox [(ngModel)]="data.isSignNoLogin" [ngModelOptions]="{ standalone: true }" style="color:rgba(0, 0, 0, 0.87) !important; "
                       *ngIf="!data.isCreatedSide && !isNotAttestedUser" (ngModelChange)="
                                  onSelectCustomerForTemplate(
                                    data.customerId,
                                    data.useDataForTemplate
                                  )
                                "
                                [nzDisabled]="data.customerId === customerMohaId && isPlContract"
                                >{{'enterprise_contract.panel_document.table_parties.header.SNL' | translate}}</label>
              </div>
              <div class="col-auto pr-0">
                <label nz-checkbox [(ngModel)]="data.signConfig.showImage" [ngModelOptions]="{ standalone: true }"
                       *ngIf="!data.isCreatedSide && data.customerType!==10000" style="color:rgba(0, 0, 0, 0.87) !important; "
                       (ngModelChange)="changeChanKy(data)"
                >{{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label>
              </div>
            </div>
          </td>
        </tr> -->
        <tr *ngIf="!data.isCreatedSide && isNotAttestedUser && data.customerType!==10000">
          <td colspan="3" *ngIf="isNotAttestedUser" [ngClass]="{'border-color-table':!data.isSetupSignFlow}">
            <label nz-checkbox [(ngModel)]="data.isSetupSignFlow" [ngModelOptions]="{ standalone: true }" #checkboxComponent1
                   style="color:rgba(0, 0, 0, 0.87) !important; "
                   *ngIf="!data.isCreatedSide && data.customerType!==10000"
                   (ngModelChange)="changeCheckbox(data,2)"
            >{{'enterprise_contract.panel_document.table_parties.header.TLLKCKH' | translate}}</label>
            <!-- <label nz-checkbox [(ngModel)]="data.signConfig.showImage" [ngModelOptions]="{ standalone: true }"  #checkboxComponent2
                   *ngIf="!data.isCreatedSide && data.customerType!==10000" style="color:rgba(0, 0, 0, 0.87) !important; "
                   [disabled]="data.isSetupSignFlow"
                   (ngModelChange)="changeCheckbox(data,1)"
            >{{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label> -->
          </td>
        </tr>
        <tr *ngIf="data.isSetupSignFlow && !data.isCreatedSide && isNotAttestedUser">
          <td [attr.rowspan]="data.customerApproves? data.customerApproves.length + 2 : 2" class="border-color-table"
          >
          </td>
          <td [attr.colspan]="setColspan(6)" style="padding: 0 !important;">
            <div *ngIf="!data.customerApproves || data.customerApproves.length == 0 " class=" mat-panel-title mat-panel-title_custom font-color-blue"  style="padding-left: 10px;">
              <a style="display: inline-block;font-size: 1em;color: inherit;text-decoration: none;margin: 0;padding: 0;  cursor: pointer;"
                 (click)="openDialogAddCustomerApprove(data,i)">  {{'button.add_approver' | translate}} </a>
              <div class="d-flex">
                <mat-icon class="mr-0 ml-1 text-primary" (click)="openDialogAddCustomerApprove(data,i)" style=" font-size: x-large; cursor: pointer"  matTooltip="{{ 'button.add_approver' | translate }}"
                          >add_circle_outline
                </mat-icon>
              </div>
<!--              matTooltip="{{ 'procedure.choose_procedure_private' | translate }}"-->
            </div>
            <div *ngIf="data.customerApproves?.length > 0" class="mat-panel-title mat-panel-title_custom font-color-blue" style="padding-left: 10px;">
              <a style="display: inline-block;font-size: 1em;color: inherit;text-decoration: none;margin: 0;padding: 0;  cursor: pointer;" (click)="openDialogAddCustomerApprove(data,i)">
              {{'button.update_approver' | translate}} </a>
              <div class="d-flex">
                <mat-icon class="mr-0 ml-1 text-primary" (click)="openDialogAddCustomerApprove(data,i)" style=" font-size: 20px; cursor: pointer" matTooltip="{{ 'button.update_approver' | translate }}"
                          >edit
                </mat-icon>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="data.isSetupSignFlow && !data.isCreatedSide && data.customerApproves?.length > 0"
             class="text-primary"
        >
          <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;background: #fafafa;">
            <div class="d-flex">
              <div class="col-1 d-flex justify-content-center" style="align-items: center;width: 5%;padding: 6px 8px; border-right: 1px solid #d9d9d9; ">
                {{
                  "enterprise_contract.panel_document.table_users.header.order"
                    | translate
                }}
              </div>
              <div class="col-3 d-flex justify-content-center" style="align-items: center;padding: 6px 8px; border-right: 1px solid #d9d9d9;">
                {{
                  "import_file.table_detail.fulName"
                    | translate
                }}
              </div>
              <div class="col-2 d-flex justify-content-center" style="align-items: center;padding: 6px 8px; border-right: 1px solid #d9d9d9;">
                {{
                  "form.phone"
                    | translate
                }}
              </div>
              <div class="col-2 d-flex justify-content-center" style="align-items: center;padding: 6px 8px; border-right: 1px solid #d9d9d9;">
                {{
                  "form.email"
                    | translate
                }}
              </div>
              <div class="col-2 d-flex justify-content-center" style="align-items: center;padding: 6px 8px; border-right: 1px solid #d9d9d9;">
                {{
                  "form.CCCD"
                    | translate
                }}
              </div>
              <div class="col-1 d-flex justify-content-center" style="align-items: center;padding: 6px 8px; border-right: 1px solid #d9d9d9;">
                {{
                  "form.aprrove_CTS"
                    | translate
                }}
              </div>
              <div class="d-flex justify-content-center" style="width: 100%; align-items: center;">
                {{
                  "form.show_image"
                    | translate
                }}
              </div>
            </div>
          </td>
          <td></td>
        </tr>
        <tr *ngFor="let user of data.customerApproves; let i = index"
            [hidden]="!(data.isSetupSignFlow && !data.isCreatedSide)">
          <td class="text-center" [ngClass]="{'border-color-table':i + 1 == data.customerApproves.length}"  [attr.colspan]="setColspan(5)" style="padding: 0 !important;" >
            <div class="d-flex" style="min-height: 40px">
              <div class="col-1 text-center d-flex justify-content-center"  style="padding: 6px 8px; border-right: 1px solid #d9d9d9; align-items: center;">
                {{
                  user.STT
                }}
              </div>
              <div class="col-3 text-left text-word  d-flex"  style="padding: 6px 8px; border-right: 1px solid #d9d9d9;align-items: center;">
                <div class="text-test">
                  {{
                  user.name
                  }}
                </div>
              </div>
              <div class="col-2 text-center text-word  d-flex justify-content-center"  style="padding: 6px 8px; border-right: 1px solid #d9d9d9;align-items: center;">
                <div class="text-test">
                {{
                 user.phoneNumber
                }}
                </div>
              </div>
              <div class="col-2 text-left text-word  d-flex "  style="padding: 6px 8px; border-right: 1px solid #d9d9d9;align-items: center;">
                <div class="text-test">
                {{
                  user.email
                }}
                </div>
              </div>
              <div class="col-2 text-left text-word  d-flex"  style="padding: 6px 8px; border-right: 1px solid #d9d9d9;align-items: center;">
                <div class="text-test">
                {{
                  user.taxCode
                }}
                </div>
              </div>
              <div class="col-1 text-word checkbox-disabled d-flex justify-content-center"  style="padding: 6px 8px; border-right: 1px solid #d9d9d9; align-items: center;">
<!--                  <mat-checkbox color="primary" [(ngModel)]="user.CTS" >-->
<!--                    &lt;!&ndash;                      (change)="onSelect(element)">&ndash;&gt;-->
<!--                  </mat-checkbox>-->
                <label nz-checkbox [(ngModel)]="user.CTS" [ngModelOptions]="{ standalone: true }"
                       style="color:rgba(0, 0, 0, 0.87) !important; "
                ></label>
              </div>
              <div class="d-flex justify-content-center checkbox-disabled " style="width: 100%; align-items: center;">
                <label nz-checkbox [(ngModel)]="user.image" [ngModelOptions]="{ standalone: true }"
                       style="color:rgba(0, 0, 0, 0.87) !important; "
                ></label>
<!--                <mat-checkbox color="primary" [(ngModel)]="user.image" >-->
<!--                  &lt;!&ndash;                      (change)="onSelect(element)">&ndash;&gt;-->
<!--                </mat-checkbox>-->
<!--                {{-->
<!--                  user.image-->
<!--                }}-->
              </div>
            </div>
          </td>
          <td  [ngClass]="{'border-color-table':i + 1 == data.customerApproves.length}"></td>
        </tr>
        <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
          <td class="border-color-table"
            [attr.rowspan]="(isValidNoUserExist || isValidExistingSigning) ?
              RECORD_USER_PERFORM_SIGN.length + 7
              : RECORD_USER_PERFORM_SIGN.length + 6"
          >
          </td>
          <td [attr.colspan]="setColspan(6)" style="padding: 0 !important;">
            <div class="mat-panel-title mat-panel-title_custom font-color-blue" style="padding-left: 10px">
              {{ "form.order_of_approval_signing_contract_unit" | translate }} &nbsp;
              <div class="d-flex">
                <mat-icon class="mr-0 text-primary" style=" font-size: x-large; cursor: pointer"
                          matTooltip="{{ 'procedure.choose_procedure_private' | translate }}"
                          (click)="openDialogProcedure(2, $event)">add_circle_outline
                </mat-icon>
              </div>
            </div>
            <!-- Nz-table set luồng ký / duyệt-->

            <!-- End Nz-table set luồng ký / duyệt-->
          </td>
        </tr>

        <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable"
            style="background: #fafafa;" class="text-primary"
        >
          <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
            <div class="d-flex">
              <div class="col-1" style="width: 40px;padding: 6px 8px; border-right: 1px solid #d9d9d9;">
                {{
                  "enterprise_contract.panel_document.table_users.header.order"
                    | translate
                }}
              </div>
              <div class="d-flex justify-content-center" style="width: 100%; align-items: center;">
                {{
                  "enterprise_contract.panel_document.table_users.header.name"
                    | translate
                }}
              </div>
            </div>
          </td>
          <td></td>
        </tr>
        <!-- Người dùng phê duyệt hợp đồng -->
        <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
          <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="mat-panel-title_custom font-color-blue col-8" style="padding-left: 10px;">
                {{ "form.contract_approver" | translate}} &nbsp;
              </div>
              <div class="font-color-blue col-2 text-center"
                   style="border-left: 1px solid #d9d9d9; padding-right: 0.75rem !important;">
                {{"enterprise_contract.panel_document.table_parties.header.sig_cts" | translate}}
              </div>
              <div class="font-color-blue col-2 text-center"
                   style="border-left: 1px solid #d9d9d9; padding-right: 0.75rem !important;">
                {{"enterprise_contract.panel_document.table_parties.header.display_signature" | translate}}
              </div>
            </div>
          </td>
          <td></td>
        </tr>

        <!-- Danh sách người dùng phê đuuyệt hợp đồng -->
        <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
            [hidden]="!(showTableMembers && data.isCreatedSide && isShowUserSignTable) || !(user.role !== '1' && data.isCreatedSide)">
          <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
            <div class="d-flex">
              <div class="col-8 d-flex" style="padding-left: 0;">
                <div class="col-1" [ngStyle]="{ 'padding': currentStep == 2 ? '15px 6.6%' : '15px 6.6%' }" style="border-right: 1px solid #d9d9d9;">
                  <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit; else isFlowNotEdit">
                    <div class="col-1 d-flex justify-content-center"  [ngStyle]="{ 'margin-left': currentStep == 2 ? '-1rem' : '-0.8rem' }">
                      {{user.order}}
                    </div>
                  </ng-container>
                  <ng-template #isFlowNotEdit>
                    <nz-input-number [ngStyle]="{ 'margin-left': currentStep == 2 ? '-1rem' : '-1.5rem' }" class="td-nz-input" [(ngModel)]="user.order" (ngModelChange)="onChangeOrderApproveSign()" [nzMin]="1"
                    [ngModelOptions]="{ standalone: true }"></nz-input-number>
                  </ng-template>
                </div>
<!--                <div class="col-2 w-75" [ngStyle]="{ 'margin-left': currentStep == 2 ? '1rem' : '' }" style="padding: 15px 0; border-right: 1px solid #d9d9d9;">-->
<!--                 </div>-->
                <div class="d-flex col-10" style="align-items: center; padding: 0 8px">
                  <div class="editable-cell" *ngIf="user.userId != null">
                    <div *ngIf="user.departmentName" class="row-icon department"><span
                      class="material-icons">apartment</span>{{ user.departmentName }}</div>
                    <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                      {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div> 
                  </div>
                </div>
              </div>
              <div class="d-flex col-2 align-items-center" style="border-left: 1px solid #d9d9d9;justify-content: center;line-height: 51px; padding-right: 0.75rem !important;">
                <label nz-checkbox [(ngModel)]="user.isSignDigitalCertificate"
                       (ngModelChange)="user.isSignDigitalCertificate ? user.signConfig.showImage = true : user.signConfig.showImage = false; changeCTS(user)"
                       [ngModelOptions]="{ standalone: true }" [nzDisabled]="selectedServiceType?.internalFlowNotEdit"
                >
                </label>
              </div>
              <div class="d-flex col-2 align-items-center" style="border-left: 1px solid #d9d9d9;justify-content: center;line-height: 51px; padding-right: 0.75rem !important;">
                <ng-container *ngIf="user.isSignDigitalCertificate">
                  <label nz-checkbox [ngModel]="user?.signConfig?.showImage"
                         (ngModelChange)="user.signConfig.showImage = $event; changeDisplaySignature(user)"
                         [ngModelOptions]="{ standalone: true }" [nzDisabled]="selectedServiceType?.internalFlowNotEdit">
                  </label>
                </ng-container>
              </div>
            </div>
          </td>
          <td class="text-center" style="position:relative; z-index: 50;">
            <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
              <a *ngIf="user.userId != null" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                  'popup.confirm_delete_user' | translate
                }}" (nzOnConfirm)="onClickDeleteElementRecordUser(user.userId, user)"
                nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
              </a>
              <ng-template #iconDel>
                <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
              <a *ngIf="user.userId != null"
              >
                <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
              </a>
            </ng-container>
          </td>
        </tr>

        <!-- Tìm kiếm người dùng phê duyệt hợp đồng -->
        <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable && !isCheckApprover">
          <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
            <div class="d-flex">
              <div class="col-8 d-flex" style="padding-left: 0;">
                <div class="col-1" [ngStyle]="{ 'padding': currentStep == 2 ? '15px 6.6%' : '15px 6.6%' }" style="border-right: 1px solid #d9d9d9;">
                </div>
                <div class="d-flex col-10 justify-content-center"
                     style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                  <div style="width: 100%;">
                    <nz-input-group [nzSuffix]="suffixUserInput">
                      <input [disabled]="warningContractQuantity || selectedServiceType?.internalFlowNotEdit" nz-input [(ngModel)]="inputUserValue"
                             (input)="onChangeUserSignSearch($event)" [nzAutocomplete]="autoUserSearching"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}" #autocompleteInput
                             id="inputUser" />
                      <nz-autocomplete #autoUserSearching>
                        <nz-auto-option *ngFor="let user of filteredUserOptions"
                                        (selectionChange)="autocompleteUserSelected($event, user)" [nzValue]="''">
                          <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department"><span
                            class="material-icons">apartment</span>{{ user.departmentName }}</div>
                          <div class="row-icon user"
                               *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                               [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                            <span class="material-icons" *ngIf="user.type === 'USER'">person</span> {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{
                              "enterprise_contract.panel_document.table_users.representative_inactive" | translate
                            }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span>
                          </div>
                          <div class="row-icon disabled user"
                               *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                            {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                          </div>
                          <hr style="margin: 0; padding: 0" />
                        </nz-auto-option>
                      </nz-autocomplete>
                    </nz-input-group>
                    <ng-template #suffixUserInput>
                      <nz-spin *ngIf="nzCheckLoadingUserSign" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
                    </ng-template>
                    <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                        style="font-size: 24px"></i></ng-template>
                  </div>
                </div>
              </div>
              <div class="d-flex col-2" style="border-left: 1px solid #d9d9d9;justify-content: center;line-height: 51px">
              </div>
              <div class="d-flex col-2" style="border-left: 1px solid #d9d9d9;justify-content: center;line-height: 51px">
              </div>
            </div>
          </td>
          <td></td>
        </tr>

        <tr
          *ngIf="checkOrder" class = "order-error-row">
          <td [attr.colspan]="setColspan(6)" class="border-color-table">
            <mat-error class="font-weight-bold" *ngIf="checkOrder"
                       style="padding-top: 0.5rem">
              {{ "validation.error_order" | translate }}
            </mat-error>
          </td>
        </tr>

        <!-- Người dùng Ký duyệt hợp đồng -->
        <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
          <td  [attr.colspan]="setColspan(6)" style="padding: 0 !important;">
            <div class="mat-panel-title_custom font-color-blue" style="padding-left: 10px">
              {{ "form.user_signs_and_approves_the_contract" | translate}}
            </div>
          </td>
        </tr>

        <!-- Danh sách người dùng Ký đuuyệt hợp đồng -->
        <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
            [hidden]="!(showTableMembers && data.isCreatedSide && isShowUserSignTable) || !(user.role === '1' && data.isCreatedSide)">
          <td class="text-center border-color-table" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
            <div class="d-flex">
              <div class="col-1 d-flex justify-content-center"  [ngStyle]="{ 'padding': currentStep == 2 ? '15px 31px' : '15px 38px' }" style="border-right: 1px solid #d9d9d9;">
                1
              </div>
              <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                <div class="editable-cell" *ngIf="user.userId != null">
                  <div *ngIf="user.departmentName" class="row-icon department"><span
                    class="material-icons">apartment</span>{{ user.departmentName }}</div>
                  <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                    {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div>
                </div>
              </div>
            </div>
          </td>
          <td class="text-center border-color-table"  *ngIf="data.isCreatedSide">
            <div class="d-flex justify-content-center">
              <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
                <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{
                    'popup.confirm_delete_party' | translate
                  }}" (nzOnConfirm)="
                    onClickDeleteElementRecordUser(user.userId, user)
                  " [nzIcon]="iconDel" nzCancelText="{{ 'button.cancel' | translate }}"
                  nzOkText="{{ 'button.ok' | translate }}">
                  <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                </a>
                <ng-template #iconDel>
                  <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
                <a
                >
                  <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
                </a>
              </ng-container>
            </div>
          </td>
          <td class="text-center border-color-table" rowspan="2" *ngIf="!data.isCreatedSide">
            <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
              <a *ngIf="user.userId != null" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                  'popup.confirm_delete_user' | translate
                }}" (nzOnConfirm)="onClickDeleteElementRecordUser(user.userId, user)"
                nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
              </a>
              <ng-template #iconDel>
                <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
              <a
              >
                <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
              </a>
            </ng-container>
          </td>
        </tr>

        <!-- Tìm kiếm người dùng Ký duyệt hợp đồng -->
        <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable && !isUserSign">
          <td [attr.colspan]="setColspan(5)" class="border-color-table" style="padding: 0 !important;">
            <div class="d-flex">
              <div class="col-1" [ngStyle]="{ 'padding': currentStep == 2 ? '15px 31px' : '15px 38px' }" style="border-right: 1px solid #d9d9d9;">
              </div>
              <div class="d-flex justify-content-center"
                   style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                <div class="w-100">
                  <nz-input-group [nzSuffix]="suffixUserInput">
                    <input [disabled]="warningContractQuantity || selectedServiceType?.internalFlowNotEdit" nz-input [(ngModel)]="inputUserSignValue"
                           (input)="onChangeUserSearch($event)" [nzAutocomplete]="autoUserSignSearching"
                           [ngModelOptions]="{ standalone: true }"
                           placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}" #autocompleteInput
                           id="inputUserSign" />
                    <nz-autocomplete #autoUserSignSearching>
                      <nz-auto-option *ngFor="let user of filteredUserOptions"
                                      (selectionChange)="autocompleteUserSignSelected($event, user)" [nzValue]="''">
                        <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department"><span
                          class="material-icons">apartment</span>{{ user.departmentName }}</div>
                        <div class="row-icon user"
                             *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                             [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                          <span class="material-icons" *ngIf="user.type === 'USER'">person</span> {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{
                            "enterprise_contract.panel_document.table_users.representative_inactive" | translate
                          }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span>
                        </div>
                        <div class="row-icon disabled user"
                             *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                          {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                        </div>
                        <hr style="margin: 0; padding: 0" />
                      </nz-auto-option>
                    </nz-autocomplete>
                  </nz-input-group>
                  <ng-template #suffixUserInput>
                    <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
                  </ng-template>
                  <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                      style="font-size: 24px"></i></ng-template>
                </div>
              </div>
            </div>
          </td>
          <td class="border-color-table"></td>
        </tr>

        <tr
          *ngIf="(isValidNoUserExist || isValidExistingSigning) && showTableMembers && data.isCreatedSide && isShowUserSignTable">
          <td [attr.colspan]="setColspan(6)" class="border-color-table">
            <mat-error class="font-weight-bold" *ngIf="isValidNoUserExist || isValidExistingSigning"
                       style="padding-top: 0.5rem">
              {{ "validation.error_user_no_set_up" | translate }}
            </mat-error>
          </td>
        </tr>

        </tbody>

        <tbody *ngIf="!checkUserSign()">
        <tr class="editable-row" *ngIf="!warningContractQuantity">
          <!-- TT -->
          <!--          <td *ngIf="!data.isCreatedSide" class="text-center" rowspan="2">-->
          <!--            <nz-input-number class="td-nz-input" [(ngModel)]="data.order" [nzMin]="1"-->
          <!--                             (ngModelChange)="onChangeOrderOfPartySign()" [ngModelOptions]="{ standalone: true }">-->
          <!--            </nz-input-number>-->
          <!--          </td>-->
          <td  class="text-center" rowspan="2">
            <nz-input-number class="td-nz-input" [(ngModel)]="valueAddPartyOrder" [nzMin]="1"
                             [ngModelOptions]="{ standalone: true }"></nz-input-number>
          </td>
          <!-- Tên -->
          <td *ngIf="!isNotAttestedUser" colspan="4">
            <div>
              <nz-input-group [nzSuffix]="suffixPartyInput">
                <input nz-input [(ngModel)]="inputPartyValue" (input)="onChangePartySignSearch($event)"
                       [nzAutocomplete]="autoPartySearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                        'placeholder.input_paperNumber' | translate
                      }}" #focusPartyInput id="inputParty" />
                <nz-autocomplete #autoPartySearching>
                  <nz-auto-option *ngFor="let party of filteredPartyOptions" (selectionChange)="
                          autocompletePartySelected($event, party)
                        " [nzValue]="''">
                    <div class="d-flex">
                      <mat-icon class="mr-2">account_circle</mat-icon>
                      <span style="line-height: 20px">
                          {{ party.name }} -
                        {{
                          party.taxCode && party.taxCode.length > 0
                            ? party.taxCode
                            : party.certificateNo
                        }}
                        </span>
                    </div>
                    <div class="d-flex">
                      <mat-icon class="mr-2">contact_mail</mat-icon>
                      <span style="line-height: 20px">
                          <span *ngIf="party.email">{{ party.email }} -</span>
                        {{ party.phone }}
                        </span>
                    </div>
                    <hr style="margin: 0; padding: 0" />
                  </nz-auto-option>
                </nz-autocomplete>
              </nz-input-group>
              <ng-template #suffixPartyInput>
                <i class="nz-icon-font" nz-icon nz-tooltip nzTitle="{{
                        'enterprise_contract.tooltips.icon_add_new_customer'
                          | translate
                      }}" nzType="plus-circle" nzTheme="outline" (click)="openAddCustomer()"
                   *ngIf="!nzCheckLoadingParty && !isFromSSO && checkDisplayIconAddCustomer()">
                </i>
                <nz-spin *ngIf="nzCheckLoadingParty" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
              </ng-template>
              <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                   style="font-size: 24px"></i>
              </ng-template>
            </div>
          </td>
          <td *ngIf="isNotAttestedUser" colspan="3">
            <div>
              <nz-input-group [nzSuffix]="suffixPartyInput">
                <input nz-input [(ngModel)]="inputPartyValue" (input)="onChangePartySignSearch($event)"
                       [nzAutocomplete]="autoPartySearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                        'placeholder.input_paperNumber' | translate
                      }}" #focusPartyInput id="inputParty" />
                <nz-autocomplete #autoPartySearching>
                  <nz-auto-option *ngFor="let party of filteredPartyOptions" (selectionChange)="
                          autocompletePartySelected($event, party)
                        " [nzValue]="''">
                    <div class="d-flex">
                      <mat-icon class="mr-2">account_circle</mat-icon>
                      <span style="line-height: 20px">
                          {{ party.name }} -
                        {{
                          party.taxCode && party.taxCode.length > 0
                            ? party.taxCode
                            : party.certificateNo
                        }}
                        </span>
                    </div>
                    <div class="d-flex">
                      <mat-icon class="mr-2">contact_mail</mat-icon>
                      <span style="line-height: 20px">
                          <span *ngIf="party.email">{{ party.email }} -</span>
                        {{ party.phone }}
                        </span>
                    </div>
                    <hr style="margin: 0; padding: 0" />
                  </nz-auto-option>
                </nz-autocomplete>
              </nz-input-group>
              <ng-template #suffixPartyInput>
                <i class="nz-icon-font" nz-icon nz-tooltip nzTitle="{{
                        'enterprise_contract.tooltips.icon_add_new_customer'
                          | translate
                      }}" nzType="plus-circle" nzTheme="outline" (click)="openAddCustomer()"
                   *ngIf="!nzCheckLoadingParty && !isFromSSO && checkDisplayIconAddCustomer()">
                </i>
                <nz-spin *ngIf="nzCheckLoadingParty" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
              </ng-template>
              <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                   style="font-size: 24px"></i>
              </ng-template>
            </div>
          </td>
          <td *ngIf="this.valueSelect == '0'"></td>
          <!--            <td *ngIf="!isNotAttestedUser"></td>-->
          <td></td>
        </tr>
        </tbody>
      </nz-table>
      
      <mat-error class="font-weight-bold" *ngIf="checkOrderUserSign()"
                       style="padding-top: 0.5rem">
              {{ "validation.error_order_2" | translate }}
      </mat-error>
      <mat-error class="font-weight-bold" *ngIf="isInvalidPartyOrder">
        Vui lòng xem kiểm tra lại dữ liệu, "Thứ tự ký" phải liên tiếp
      </mat-error>
      <mat-error class="font-weight-bold" *ngIf="isInvalidSetPartyFlow">
        {{ "validation.error_enterprise_no_set_up" | translate }}
      </mat-error>
      <mat-error class="font-weight-bold" *ngIf="isEmailInvalid && !isPhoneInvalid">
        {{ "validation.error_email_format" | translate }}
      </mat-error>
      <mat-error class="font-weight-bold" *ngIf="!isEmailInvalid && isPhoneInvalid">
        {{ "validation.error_phone_format" | translate }}
      </mat-error>
      <mat-error class="font-weight-bold" *ngIf="isEmailInvalid && isPhoneInvalid">
        {{ "validation.error_email_phone_format" | translate }}
      </mat-error>
    </form>
    <div class="mt-1" *ngIf="!isNotAttestedUser">
      <!--      <span class="span-guiding">-->
      <!--        <b>- {{-->
      <!--            "enterprise_contract.panel_document.table_parties.header.sign_no_login"-->
      <!--              | translate-->
      <!--          }}</b>:-->
      <!--        {{-->
      <!--          "enterprise_contract.panel_document.table_parties.guide_sign_no_login"-->
      <!--            | translate-->
      <!--        }}-->
      <!--    </span>-->
    </div>
    <ng-container *ngIf="valueSelectType == 0 && typeDoc == 2">
      <span class="span-guiding text-danger">
        - {{"enterprise_contract.panel_document.table_parties.message_sign_no_login" | translate}}
      </span>
    </ng-container>
    <span class="span-guiding" *ngIf="this.valueSelect == '0'"><b>{{
        "enterprise_contract.panel_document.table_parties.header.insert_infor"
          | translate
      }}</b>:
      {{
        "enterprise_contract.panel_document.table_parties.guide_insert_infor"
          | translate
      }}</span>
    <!-- End of Nz-table set chu the-->
  </mat-expansion-panel>

  <!-- Nz-table set luồng ký / duyệt-->

  <!-- End Nz-table set luồng ký / duyệt-->

  <!-- Nz-table thông tin Chuyển tiếp hợp đồng-->

  <!-- End Nz-table thông tin Chuyển tiếp hợp đồng-->

</mat-accordion>
<mat-expansion-panel *ngIf="check == 2" expanded="false" class="mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-description class="mat-panel-title">
      {{ "form.set_up_contract_forwarding_flow" | translate }} &nbsp;
    </mat-panel-description>
  </mat-expansion-panel-header>
  <form nz-frm>
    <nz-table #editRowInternalTable nzBordered [nzData]="RECORD_INTERNAL_USER" [nzShowPagination]="false"
              [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
      <thead>
      <tr>
        <th class="text-center" nzWidth="25px">
          {{
            "enterprise_contract.panel_document.table_users.header.order"
              | translate
          }}
        </th>
        <th class="text-center" nzWidth="80%">
          {{
            "enterprise_contract.panel_document.table_users.header.name"
              | translate
          }}
        </th>
        <th class="text-center">
<!--          {{-->
<!--            "enterprise_contract.panel_document.table_users.header.action"-->
<!--              | translate-->
<!--          }}-->
        </th>
      </tr>
      </thead>
      <tbody class="order-row">
      <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
        <!-- TT -->
        <td class="text-center">{{ i + 1 }}</td>
        <!-- Tên -->
        <td class="word-break-line">
          <div class="editable-cell">
            <div *ngIf="data.type === 'DEPARTMENT'" class="row-icon department"><span
              class="material-icons">apartment</span>{{ data.departmentCode }} - {{ data.departmentName }}</div>
            <div class="row-icon user"
              *ngIf="(data.type === 'DEPARTMENT' && data.representativeId) || data.type === 'USER'"
              [class.disabled]="!data.representativeIsActive && data.type === 'DEPARTMENT'">
              <span class="material-icons" *ngIf="data.type === 'USER'">person</span> {{data.name}} <span *ngIf="data.email">- {{data.email}} </span>
              <span *ngIf="!data.representativeIsActive && data.type === 'DEPARTMENT'">{{"enterprise_contract.panel_document.table_users.representative_inactive" | translate }}</span>
              <span *ngIf="data.userPosition"> - {{data.userPosition}} </span>
            </div>
            <div class="row-icon disabled user"
              *ngIf="!data.representativeId && data.type === 'DEPARTMENT'">
              {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
            </div>
          </div>
        </td>

        <!-- Action -->
        <td class="td-nz-icon text-center">
          <a nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                  'popup.confirm_delete_user_or_derpartment' | translate
                }}" (nzOnConfirm)="onClickDeleteElementRecordInternalUser(data.id)"
             nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
            <!-- <i class="nz-icon-font" nz-icon nzType="close-square" nzTheme="outline" nz-tooltip
 nzTitle="{{ 'tooltips.delete' | translate }}"></i> -->
            <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
          </a>
          <ng-template #iconDel>
            <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
          </ng-template>
        </td>
      </tr>
      <tr class="editable-row">
        <!-- TT -->
        <td class="text-center">&nbsp;</td>
        <!-- Tên -->
        <td>
          <div>
            <nz-input-group [nzSuffix]="suffixInternalUserInput">
              <input [disabled]="warningContractQuantity" nz-input [(ngModel)]="inputInternalUsersValue"
                     (input)="onChangeInternalUsersSearch($event)" [nzAutocomplete]="autoInternalUserSearching"
                     [ngModelOptions]="{ standalone: true }" placeholder="{{ 'enterprise_contract.panel_document.table_users.placeholder_search_user_or_department' | translate }}"
                     #autocompleteInput id="inputUser1" />
              <nz-autocomplete #autoInternalUserSearching>
                <nz-auto-option *ngFor="let user of filteredInternalUsersOptions"
                                (selectionChange)="autocompleteInternalUserSelected($event, user)" [nzValue]="''">
                  <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department"><span
                    class="material-icons">apartment</span>{{ user.departmentCode }} - {{ user.departmentName }}</div>
                  <div class="row-icon user"
                    *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                    [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                    <span class="material-icons" *ngIf="user.type === 'USER'">person</span> {{user.name}} <span *ngIf="user.email">- {{user.email}} </span>
                    <span *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{"enterprise_contract.panel_document.table_users.representative_inactive" | translate }}</span>
                    <span *ngIf="user.userPosition"> - {{user.userPosition}} </span>
                  </div>
                  <div class="row-icon disabled user"
                    *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                    {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                  </div>
                  <hr style="margin: 0; padding: 0" />
                </nz-auto-option>
              </nz-autocomplete>
            </nz-input-group>
            <ng-template #suffixInternalUserInput>
              <nz-spin *ngIf="nzCheckLoadingInternalUsers" nzSimple [nzIndicator]="indicatorInternalUserInput">
              </nz-spin>
            </ng-template>
            <ng-template #indicatorInternalUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                        style="font-size: 24px"></i></ng-template>
          </div>
        </td>
        <!-- Thực hiện -->
        <td class="td-nz-icon text-center">&nbsp;</td>
      </tr>
      </tbody>
    </nz-table>
  </form>
</mat-expansion-panel>
<ng-template #contentEmptyTable let-name></ng-template>
<!-- </div> -->
